import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "accepted-circle",
  "use": "accepted-circle-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\" id=\"accepted-circle\"><path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#00BB28\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M23.5.5 9 18.5l-5-5m14.273-1.006A9 9 0 1 1 13.5 6.436\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol